import type { FC } from 'react'
import { PropsWithChildren } from 'react'
import { Stack, IconButton, type IconButtonProps } from '@mui/material'
import { Close } from '@dhl/icons'

type DialogTitleClosableProps = {
  onClose?: IconButtonProps['onClick']
  closeSize?: 'inherit' | 'large' | 'medium' | 'small'
  px?: number
  py?: number
}

export const DialogTitleClosable: FC<PropsWithChildren<DialogTitleClosableProps>> = ({
  onClose,
  children,
  closeSize = 'inherit',
  px = 2,
  py = 1,
}) => (
  /* Perhaps put the DialogTitle back if everyone passes a string instead of a typography */
  <Stack flexDirection="row" justifyContent="space-between" alignItems="center" px={px} py={py}>
    {children}
    {onClose && (
      <IconButton
        data-test="dialog-title-closable"
        sx={{ marginLeft: 'auto', marginRight: '-10px', zIndex: 1 }}
        onClick={onClose}
      >
        <Close fontSize={closeSize} />
      </IconButton>
    )}
  </Stack>
)
